import React, { useEffect } from "react";
import {
  getProfitLossAPI,
  getProfitLossReportAPI,
} from "../service/AuthService";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export default function ProfitLoss() {
  const [data, setData] = React.useState([]);
  const navigate = useNavigate();
  const userData = useSelector((state) => state.account.userData);
  const [page, setPage] = React.useState({
    page: 1,
    pageSize: 10,
    total: 0,
  });
  const [payload, setPayload] = React.useState({
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    type: "ALL",
  });
  const [refs, setRefs] = React.useState({
    startDate: React.createRef(),
    endDate: React.createRef(),
  });
  const getProfitLoss = async () => {
    const { response } = await getProfitLossAPI({
      startTime: moment(payload.startDate).add(5, "hours").add(30, "minutes"),
      endTime: moment(payload.endDate).add(5, "hours").add(30, "minutes"),
    });
    if (response) {
      setData(response);
    }
  };
  useEffect(() => {
    getProfitLoss();
  }, []);
  return (
    <app-profit-loss _nghost-ng-c3467425391="" className="ng-star-inserted">
      <div _ngcontent-ng-c3467425391="" className="cardMain">
        <div _ngcontent-ng-c3467425391="" className="row">
          <div
            _ngcontent-ng-c3467425391=""
            className="col-sm-12 col-md-12 p-mobile-1 card-main-con"
          >
            <div
              _ngcontent-ng-c3467425391=""
              className="card card-report card-accent-primary"
            >
              <div
                _ngcontent-ng-c3467425391=""
                className="card-body row p-0 mb-2"
              >
                <div
                  _ngcontent-ng-c3467425391=""
                  className="col-md-12 betHistory"
                >
                  <div _ngcontent-ng-c3467425391="" className="row">
                    <div
                      _ngcontent-ng-c3467425391=""
                      className="col-md-3 col-12 slct-dat"
                    >
                      <div _ngcontent-ng-c3467425391="" className="form-group">
                        <select
                          _ngcontent-ng-c3467425391=""
                          id="datasourceSelect"
                          className="form-control custom-select ng-untouched ng-pristine ng-valid"
                        >
                          <option _ngcontent-ng-c3467425391="" value="">
                            Data Source
                          </option>
                          <option _ngcontent-ng-c3467425391="" value="LIVE">
                            LIVE DATA
                          </option>
                          <option _ngcontent-ng-c3467425391="" value="BACKUP">
                            BACKUP DATA
                          </option>
                          <option _ngcontent-ng-c3467425391="" value="OLD">
                            OLD DATA
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c485763188=""
                      className="col-md-3 col-12 mb-2 pick-date-slct"
                    >
                      <div
                        _ngcontent-ng-c485763188=""
                        className="form-group mb-0"
                      >
                        <div
                          _ngcontent-ng-c485763188=""
                          className="input-group"
                        >
                          <div
                            _ngcontent-ng-c485763188=""
                            placeholder="Select Date"
                            name="mydate"
                            readOnly=""
                            autoComplete="off"
                            angular-mydatepicker=""
                            className="form-control my-date-picker picker-border ng-untouched ng-pristine ng-valid"
                          >
                            <div className="mydp" style={{ width: "100%" }}>
                              <div className="selectiongroup ng-star-inserted">
                                <input
                                  ref={refs.startDate}
                                  value={payload.startDate}
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      startDate: e.target.value,
                                    })
                                  }
                                  style={{
                                    width: "100%",
                                    height: 34,
                                    fontSize: 14,
                                    border: "none",
                                    icon: "none",
                                  }}
                                  className="  "
                                  placeholder="Select Date"
                                  type="date"
                                  aria-label="Date input field"
                                  max={moment().format("YYYY-MM-DD")}
                                />
                                {/**/}
                                <div
                                  className="selbtngroup"
                                  style={{ height: 34 }}
                                >
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  <button
                                    type="button"
                                    onClick={() => {
                                      refs.startDate.current.click();
                                    }}
                                    className="btnpicker btnpickerenabled"
                                    aria-label="Open Calendar"
                                  >
                                    <span className="mydpicon icon-mydpcalendar" />
                                  </button>
                                </div>
                              </div>

                              {/**/}
                              {/**/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c485763188=""
                      className="col-md-3 col-12 mb-2 pick-date-slct-two"
                    >
                      <div
                        _ngcontent-ng-c485763188=""
                        className="form-group mb-0"
                      >
                        <div
                          _ngcontent-ng-c485763188=""
                          className="input-group"
                        >
                          <div
                            _ngcontent-ng-c485763188=""
                            placeholder="Select Date"
                            name="mydate"
                            readOnly=""
                            autoComplete="off"
                            angular-mydatepicker=""
                            className="form-control my-date-picker picker-border ng-untouched ng-pristine ng-valid"
                          >
                            <div className="mydp" style={{ width: "100%" }}>
                              <div className="selectiongroup ng-star-inserted">
                                <input
                                  ngtype="text"
                                  autoComplete="off"
                                  spellCheck="false"
                                  autoCorrect="off"
                                  value={payload.endDate}
                                  onChange={(e) =>
                                    setPayload({
                                      ...payload,
                                      endDate: e.target.value,
                                    })
                                  }
                                  type="date"
                                  max={moment().format("YYYY-MM-DD")}
                                  min={moment(payload.startDate).format(
                                    "YYYY-MM-DD"
                                  )}
                                  className=""
                                  placeholder="Select Date"
                                  aria-label="Date input field"
                                  style={{
                                    width: "100%",
                                    height: 34,
                                    fontSize: 14,
                                    border: "none",
                                    icon: "none",
                                  }}
                                />
                                {/**/}
                                <div
                                  className="selbtngroup"
                                  style={{ height: 34 }}
                                >
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  <button
                                    type="button"
                                    onClick={getProfitLoss}
                                    className="btnpicker btnpickerenabled"
                                    aria-label="Open Calendar"
                                  >
                                    <span className="mydpicon icon-mydpcalendar" />
                                  </button>
                                </div>
                              </div>
                              {/**/}
                              {/**/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      _ngcontent-ng-c3467425391=""
                      className="col-md-3 col-6 gpl-con slct-date-pick-btn"
                    >
                      <button
                        onClick={getProfitLoss}
                        _ngcontent-ng-c3467425391=""
                        type="button"
                        className="btn btn-primary btnn"
                        disabled=""
                      >
                        <strong _ngcontent-ng-c3467425391="">
                          Get P&amp;L
                        </strong>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div _ngcontent-ng-c3467425391="" className="row">
          <div
            _ngcontent-ng-c3467425391=""
            className="col-sm-12 col-md-12 p-mobile-1"
          >
            <div
              _ngcontent-ng-c3467425391=""
              className="card card-accent-primary"
            >
              <div
                _ngcontent-ng-c3467425391=""
                className="card-header account-detail-head"
              >
                <span _ngcontent-ng-c3467425391="" className="pl-con">
                  Profit/Loss
                </span>
              </div>
              <div
                _ngcontent-ng-c3467425391=""
                className="card-body account-stat-body"
              >
                <div _ngcontent-ng-c3467425391="" className="row">
                  <div
                    _ngcontent-ng-c3467425391=""
                    className="col-md-12 p-mobile-0"
                  >
                    <div
                      id="DataTables_Table_3_wrapper"
                      className="dataTables_wrapper"
                    >
                      <div
                        className="dataTables_length"
                        id="DataTables_Table_3_length"
                      >
                        <label>
                          Show{" "}
                          <select
                            name="DataTables_Table_3_length"
                            aria-controls="DataTables_Table_3"
                            className=""
                            value={page.pageSize}
                            onChange={(e) =>
                              setPage({
                                ...page,
                                pageSize: e.target.value,
                              })
                            }
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>{" "}
                          entries
                        </label>
                      </div>
                      <table
                        _ngcontent-ng-c3467425391=""
                        datatable=""
                        className="row-border no-footer table table-hover table-responsive dataTable"
                        id="DataTables_Table_3"
                        aria-describedby="DataTables_Table_3_info"
                      >
                        <thead _ngcontent-ng-c3467425391="">
                          <tr _ngcontent-ng-c3467425391="">
                            <th
                              _ngcontent-ng-c3467425391=""
                              className="text-center sorting sorting_asc"
                              tabIndex={0}
                              aria-controls="DataTables_Table_3"
                              rowSpan={1}
                              colSpan={1}
                              aria-sort="ascending"
                              aria-label="Sport Name: activate to sort column descending"
                            >
                              Sport Name
                            </th>
                            <th
                              _ngcontent-ng-c3467425391=""
                              className="text-center sorting"
                              tabIndex={0}
                              aria-controls="DataTables_Table_3"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="Profit/Loss: activate to sort column ascending"
                            >
                              Profit/Loss
                            </th>
                            <th
                              _ngcontent-ng-c3467425391=""
                              className="text-center sorting"
                              tabIndex={0}
                              aria-controls="DataTables_Table_3"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="Commission: activate to sort column ascending"
                            >
                              Commission
                            </th>
                            <th
                              _ngcontent-ng-c3467425391=""
                              className="text-center sorting_disabled"
                              rowSpan={1}
                              colSpan={1}
                              aria-label="Total P&amp;L"
                            >
                              Total P&amp;L
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item) => (
                            <tr _ngcontent-ng-c3467425391="" className="odd">
                              <td
                                _ngcontent-ng-c3467425391=""
                                className="text-center"
                                onClick={() => {
                                  navigate(
                                    `/profitloss/${item.sport}/${payload.startDate}/${payload.endDate}`
                                  );
                                }}
                                style={{
                                  cursor: "pointer",
                                  color: "#007bff",
                                  textDecoration: "underline",
                                }}
                              >
                                {item.sport}
                              </td>
                              <td
                                _ngcontent-ng-c3467425391=""
                                className={`text-center ${
                                  item.profitLoss < 0
                                    ? "text-danger"
                                    : "text-success"
                                }`}
                              >
                                {item.profitLoss}
                              </td>
                              <td
                                _ngcontent-ng-c3467425391=""
                                className="text-center"
                              >
                                {item?.commission}
                              </td>
                              <td
                                _ngcontent-ng-c3467425391=""
                                className={`text-center ${
                                  (item.profitLoss < 0
                                    ? Math.abs(item.profitLoss)
                                    : -item?.profitLoss) +
                                    item?.commission <
                                  0
                                    ? "text-danger"
                                    : "text-success"
                                }`}
                              >
                                {(item.profitLoss < 0
                                  ? Math.abs(item.profitLoss)
                                  : -item?.profitLoss) + item?.commission}
                              </td>
                            </tr>
                          ))}
                          {data.length == 0 && (
                            <tr className="odd">
                              <td
                                valign="top"
                                colSpan={4}
                                className="dataTables_empty"
                              >
                                No data available in table
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/**/}
                        <tfoot
                          _ngcontent-ng-c3467425391=""
                          className="ng-star-inserted"
                        >
                          <tr _ngcontent-ng-c3467425391="">
                            <td
                              _ngcontent-ng-c3467425391=""
                              colSpan={4}
                              className="text-center"
                              rowSpan={1}
                            >
                              No data!
                            </td>
                          </tr>
                        </tfoot>
                        {/**/}
                      </table>
                      <div
                        className="dataTables_info"
                        id="DataTables_Table_3_info"
                        role="status"
                        aria-live="polite"
                      >
                        Showing 0 to 0 of 0 entries
                      </div>
                      <div
                        className="dataTables_paginate paging_full_numbers"
                        id="DataTables_Table_3_paginate"
                      >
                        <a
                          className="paginate_button first disabled"
                          aria-controls="DataTables_Table_3"
                          aria-disabled="true"
                          role="link"
                          data-dt-idx="first"
                          tabIndex={-1}
                          id="DataTables_Table_3_first"
                        >
                          First
                        </a>
                        <a
                          className="paginate_button previous disabled"
                          aria-controls="DataTables_Table_3"
                          aria-disabled="true"
                          role="link"
                          data-dt-idx="previous"
                          tabIndex={-1}
                          id="DataTables_Table_3_previous"
                        >
                          Previous
                        </a>
                        <span />
                        <a
                          className="paginate_button next disabled"
                          aria-controls="DataTables_Table_3"
                          aria-disabled="true"
                          role="link"
                          data-dt-idx="next"
                          tabIndex={-1}
                          id="DataTables_Table_3_next"
                        >
                          Next
                        </a>
                        <a
                          className="paginate_button last disabled"
                          aria-controls="DataTables_Table_3"
                          aria-disabled="true"
                          role="link"
                          data-dt-idx="last"
                          tabIndex={-1}
                          id="DataTables_Table_3_last"
                        >
                          Last
                        </a>
                      </div>
                    </div>
                    {/**/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-profit-loss>
  );
}
